// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1654":"50580413","2362":"50580413","6771":"50580413","7716":"3307e9b0"}[chunkId] + ".chunk.css";
};